'use client';

import { ElementProps } from '@/components/sections/builder/types';

import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { IBlogPost } from '@/types/blog';

export default function ElementContent({ element, preview, data }: ElementProps) {
  const childs = element.childs;
  const content = element.data as BlogDetailTitleElementDataType;
  const details = data || ({} as IBlogPost);

  return (
    <>
      <section className='blog-detail-padding bg_section'>
        <div className='theme_layout_page_width textImportant mx-auto duration-100'>
          <div className='theme_layout_space_section'>
            <div className='mx-auto my-4 max-w-5xl px-4 xl:min-h-[calc(100vh_-_300px)]'>
              {(childs || []).map((child) => (
                <WrapperChild
                  child={{
                    ...child,
                    parentData: {
                      ...details,
                      ...content,
                    },
                  }}
                  parentType={element.type}
                  key={child.id}
                  preview={preview}
                  data={details}
                  className=''
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .blog-detail-padding {
            padding-top: ${content.padding?.top || 0}px;
            padding-bottom: ${content.padding?.bottom || 0}px;
          }
          .bg_section {
            background-color: ${content.colorSchemeSection?.background || 'white'};
          }

          .bg_section p.text-node,
          .bg_section h1,
          .bg_section h2,
          .bg_section span {
            color: ${content.colorSchemeSection?.text || 'black'} !important;
          }

          .textImportant {
            color: ${content.colorSchemeSection?.text || 'black'} !important;
          }
        `}
      </style>
    </>
  );
}
